/* 4Falcons Pixel Match — small progressive enhancements only. */
(function () {
  'use strict';

  var CFG = window.PXCFG || {};

  // Quantity steppers — the change event lets the AJAX cart react without
  // a page reload (and the PDP form simply keeps the new value).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var box = btn.closest('.qty');
    var input = box && box.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(parseInt(input.min, 10) || 0, v + (btn.dataset.qty === 'up' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Vehicle finder: compose the selections into a catalog search
  var finder = document.querySelector('[data-finder]');
  if (finder) {
    finder.addEventListener('submit', function (e) {
      e.preventDefault();
      var kw = finder.querySelector('input[name="q"]');
      var parts = [];
      if (kw && kw.value.trim()) {
        // A typed part number or keyword is precise — never dilute it
        // with leftover dropdown selections.
        parts = [kw.value.trim()];
      } else {
        finder.querySelectorAll('select').forEach(function (s) { if (s.value) parts.push(s.value); });
      }
      var q = parts.join(' ');
      window.location.href = finder.dataset.finder + '?type=product&q=' + encodeURIComponent(q);
    });
  }

  // Product gallery thumbnails — crossfade the main image on swap
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    e.preventDefault();
    var main = document.querySelector('[data-main-image]');
    if (main) {
      main.style.opacity = '0';
      setTimeout(function () {
        if (t.dataset.thumbSrcset) main.setAttribute('srcset', t.dataset.thumbSrcset);
        else main.removeAttribute('srcset');
        main.src = t.dataset.thumb;
        var show = function () { main.style.opacity = '1'; };
        if (main.complete) show(); else main.addEventListener('load', show, { once: true });
        setTimeout(show, 400);
      }, 160);
    }
    document.querySelectorAll('[data-thumb]').forEach(function (el) { el.classList.remove('on'); });
    t.classList.add('on');
  });

  // Live search suggestions — products appear as the shopper types, using
  // Shopify's native predictive search API (no app needed). Matches titles,
  // vendors, product types and variant SKUs (part numbers).
  var escHtml = function (s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var sbId = 0;
  document.querySelectorAll('form.searchbar').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || !window.fetch) return;
    input.setAttribute('autocomplete', 'off');
    var panel = document.createElement('div');
    panel.className = 'suggest';
    sbId += 1;
    panel.id = 'px-suggest-' + sbId;
    panel.setAttribute('role', 'listbox');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);
    form.appendChild(panel);
    var timer = null, ctrl = null, sel = -1;

    var close = function () {
      panel.classList.remove('open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      sel = -1;
    };
    var allLink = function (q) {
      return '<a class="sall" href="' + form.getAttribute('action') + '?type=product&q=' +
        encodeURIComponent(q) + '">View all results for “' + escHtml(q) + '”</a>';
    };
    var rowHtml = function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      if (img) img = sizedImg(img, 120);
      var price = '';
      if (p.price) {
        var cents = Math.round(parseFloat(String(p.price).replace(/[^0-9.]/g, '')) * 100);
        price = isNaN(cents) ? String(p.price) : pxMoney(cents);
      }
      return '<a class="srow" href="' + escHtml(p.url) + '">' +
        '<span class="sim">' + (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="st">' + (p.vendor ? '<small>' + escHtml(p.vendor) + '</small>' : '') +
        '<b>' + escHtml(p.title) + '</b></span>' +
        (price ? '<span class="sp">' + escHtml(price) + '</span>' : '') + '</a>';
    };
    var run = function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      if (!panel.classList.contains('open')) {
        panel.innerHTML = '<div class="sload"><div class="sk"></div><div class="sk"></div><div class="sk"></div></div>';
        panel.classList.add('open');
        input.setAttribute('aria-expanded', 'true');
      }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku',
        ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          var prods = ((((data || {}).resources || {}).results || {}).products) || [];
          sel = -1;
          input.removeAttribute('aria-activedescendant');
          panel.innerHTML = (prods.length
            ? prods.map(rowHtml).join('')
            : '<div class="sempty">No quick matches for “' + escHtml(q) + '”</div>') + allLink(q);
          panel.querySelectorAll('.srow').forEach(function (r, i) {
            r.id = panel.id + '-opt-' + i;
            r.setAttribute('role', 'option');
          });
          panel.classList.add('open');
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {});
    };

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) run();
    });
    input.addEventListener('keydown', function (e) {
      if (!panel.classList.contains('open')) return;
      var rows = panel.querySelectorAll('.srow');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!rows.length) return;
        sel = e.key === 'ArrowDown'
          ? (sel + 1) % rows.length
          : (sel - 1 + rows.length) % rows.length;
        rows.forEach(function (r, i) { r.classList.toggle('sel', i === sel); });
        if (rows[sel] && rows[sel].id) input.setAttribute('aria-activedescendant', rows[sel].id);
      } else if (e.key === 'Enter' && sel >= 0 && rows[sel]) {
        e.preventDefault();
        window.location.href = rows[sel].getAttribute('href');
      } else if (e.key === 'Escape') {
        close();
      }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  });

  // Faceted filters: on desktop each checkbox applies immediately. Inside
  // the mobile drawer taps are batched behind one "Apply" button so the
  // drawer doesn't vanish into a page reload after every selection.
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (!form || e.target.type !== 'checkbox') return;
    if (document.body.classList.contains('facets-open')) {
      var apply = form.querySelector('[data-facets-apply]');
      if (apply) {
        var n = form.querySelectorAll('input[type="checkbox"]:checked').length;
        apply.textContent = 'Apply filters' + (n ? ' (' + n + ')' : '');
      }
      return;
    }
    form.submit();
  });

  // Search box on long filter groups (e.g. hundreds of brands). The input
  // sits above the scrollable list so it never scrolls out of view.
  document.addEventListener('input', function (e) {
    var s = e.target.closest('[data-fsearch]');
    if (!s) return;
    var q = s.value.trim().toLowerCase();
    var group = s.closest('.fgroup');
    var body = group ? group.querySelector('.fbody') : s.closest('.fbody');
    if (!body) return;
    var any = false;
    body.querySelectorAll('.fcheck').forEach(function (row) {
      var hit = !q || row.textContent.toLowerCase().indexOf(q) !== -1;
      row.style.display = hit ? '' : 'none';
      if (hit) any = true;
    });
    var none = body.querySelector('.fnores');
    if (!any && !none) {
      none = document.createElement('div');
      none.className = 'fnores';
      none.textContent = 'No matches';
      body.appendChild(none);
    }
    if (none) none.style.display = any ? 'none' : '';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-fsearch]')) e.preventDefault();
  });

  // Sort select: swap sort_by in the URL, keeping every active filter
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-by]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Filters drawer (tablet/phone) — with focus handling so keyboard and
  // screen-reader users land inside and can Escape out.
  var facetsPanel = document.querySelector('[data-facets]');
  var facetsOpener = null;
  var facetsSet = function (open) {
    document.body.classList.toggle('facets-open', open);
    if (!facetsPanel) return;
    if (open) {
      facetsOpener = document.activeElement;
      facetsPanel.setAttribute('tabindex', '-1');
      facetsPanel.focus({ preventScroll: true });
    } else if (facetsOpener && facetsOpener.focus) {
      facetsOpener.focus({ preventScroll: true });
      facetsOpener = null;
    }
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-facets-open]')) facetsSet(true);
    if (e.target.closest('[data-facets-close]')) facetsSet(false);
    if (e.target === document.body && document.body.classList.contains('facets-open')) {
      facetsSet(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('facets-open')) facetsSet(false);
  });

  // Client-side fallback filter (stores without storefront filters set up):
  // price min/max + in-stock instantly hide cards on the current page.
  var cf = document.querySelector('[data-client-filter]');
  var grid = document.querySelector('[data-plp-grid]');
  if (cf && grid) {
    var applyCf = function () {
      var minEl = cf.querySelector('[data-cf-min]');
      var maxEl = cf.querySelector('[data-cf-max]');
      var stockEl = cf.querySelector('[data-cf-stock]');
      var min = minEl && minEl.value !== '' ? parseFloat(minEl.value) : null;
      var max = maxEl && maxEl.value !== '' ? parseFloat(maxEl.value) : null;
      var stock = !!(stockEl && stockEl.checked);
      var shown = 0, total = 0;
      grid.querySelectorAll('.pcard').forEach(function (card) {
        total += 1;
        var price = parseFloat(card.dataset.price || '0');
        var ok = true;
        if (min !== null && price < min) ok = false;
        if (max !== null && price > max) ok = false;
        if (stock && card.dataset.available !== 'true') ok = false;
        card.style.display = ok ? '' : 'none';
        if (ok) shown += 1;
      });
      var empty = document.querySelector('[data-cf-empty]');
      if (empty) empty.hidden = shown !== 0;
      var note = cf.querySelector('[data-cf-note]');
      if (note) {
        var filtering = min !== null || max !== null || stock;
        note.hidden = !filtering;
        note.textContent = filtering ? 'Showing ' + shown + ' of ' + total + ' on this page' : '';
      }
    };
    cf.addEventListener('input', applyCf);
    cf.addEventListener('change', applyCf);
  }

  // Sticky Add-to-Cart bar: appears once the main buy button scrolls away
  var satc = document.querySelector('[data-satc]');
  var mainAtc = document.querySelector('[data-main-atc]');
  if (satc && mainAtc && 'IntersectionObserver' in window) {
    var satcIo = new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting;
      var shown = !vis && window.scrollY > 200;
      satc.classList.toggle('show', shown);
      document.body.classList.toggle('satc-open', shown);
      satc.setAttribute('aria-hidden', shown ? 'false' : 'true');
      if ('inert' in satc) satc.inert = !shown;
    }, { threshold: 0 });
    satcIo.observe(mainAtc);
    var satcBtn = satc.querySelector('[data-satc-add]');
    if (satcBtn) {
      satcBtn.addEventListener('click', function () { mainAtc.click(); });
    }
    var vsel = document.querySelector('.variant-select');
    var satcPrice = satc.querySelector('[data-satc-price]');
    if (vsel && satcPrice) {
      vsel.addEventListener('change', function () {
        var opt = vsel.options[vsel.selectedIndex];
        if (opt && opt.dataset.price) satcPrice.textContent = opt.dataset.price;
      });
    }
  }

  // Same-day dispatch countdown ("Order within 4h 32m ..."). Past ~24h
  // (weekends) a live timer reads absurd, so it becomes a deadline instead
  // ("Order by Mon 3 PM ...").
  var dispatchEl = document.querySelector('[data-dispatch]');
  if (dispatchEl) {
    var dOut = dispatchEl.querySelector('[data-dispatch-time]');
    var dPrefix = dispatchEl.querySelector('[data-dispatch-prefix]');
    var dCutoff = parseInt(dispatchEl.dataset.cutoff, 10) || 15;
    var dOffset = parseFloat(dispatchEl.dataset.offset) || 0;
    var dWeekdays = dispatchEl.dataset.weekdays === 'true';
    var dispatchTick = function () {
      // Work in the store's timezone by shifting UTC, then use UTC getters.
      var store = new Date(Date.now() + dOffset * 3600000);
      var target = new Date(store.getTime());
      target.setUTCHours(dCutoff, 0, 0, 0);
      if (target <= store) target.setUTCDate(target.getUTCDate() + 1);
      if (dWeekdays) {
        while (target.getUTCDay() === 0 || target.getUTCDay() === 6) {
          target.setUTCDate(target.getUTCDate() + 1);
        }
      }
      var diff = target - store;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      if (!dOut) return;
      if (h >= 24) {
        var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var hr12 = (dCutoff % 12) || 12;
        if (dPrefix) dPrefix.textContent = 'Order by';
        dOut.textContent = days[target.getUTCDay()] + ' ' + hr12 + (dCutoff < 12 ? ' AM' : ' PM');
      } else {
        if (dPrefix) dPrefix.textContent = 'Order within';
        dOut.textContent = (h > 0 ? h + 'h ' : '') + m + 'm';
      }
    };
    dispatchTick();
    setInterval(dispatchTick, 20000);
  }

  // Money formatting that honors the store's configured format (currency
  // symbol, decimals, separators) instead of hardcoding "$".
  var pxMoney = (function () {
    var fmt = CFG.moneyFormat || '${{amount}}';
    return function (cents) {
      var v = (parseInt(cents, 10) || 0) / 100;
      var parts = v.toFixed(2).split('.');
      var out;
      if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
        out = String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else if (fmt.indexOf('amount_no_decimals') !== -1) {
        out = String(Math.round(v));
      } else if (fmt.indexOf('amount_with_comma_separator') !== -1) {
        out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      } else {
        out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      }
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, out);
    };
  })();

  // Shared client-side product card renderer (recommendations + recently viewed)
  var pxCard = function (p) {
    var onSale = p.cap && p.cap > p.price;
    var cta = '';
    if (p.opts) {
      // Multi-variant products need a choice — silently adding the first
      // variant causes wrong-part orders and returns.
      cta = '<div class="pcard-cta"><a class="atc atc-link" href="' + escHtml(p.url) + '">Choose Options</a></div>';
    } else if (p.vid) {
      cta = '<form method="post" action="' + (CFG.cartAddUrl || '/cart/add') + '" class="pcard-cta">' +
        '<input type="hidden" name="id" value="' + p.vid + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button class="atc" type="submit"' + (p.available ? '' : ' disabled') + '>' +
        (p.available ? 'Add to Cart' : 'Sold Out') + '</button></form>';
    }
    return '<div class="pcard">' +
      (onSale ? '<span class="sale">Sale</span>' : '') +
      '<a class="im" href="' + escHtml(p.url) + '">' +
      (p.img ? '<img src="' + escHtml(p.img) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="in">' +
      (p.vendor ? '<span class="brand">' + escHtml(p.vendor) + '</span>' : '') +
      '<h3><a href="' + escHtml(p.url) + '">' + escHtml(p.title) + '</a></h3>' +
      '<div class="prow"><span class="pnow' + (onSale ? ' on' : '') + '">' + pxMoney(p.price) + '</span>' +
      (onSale ? '<span class="pwas">' + pxMoney(p.cap) + '</span>' : '') + '</div>' +
      (p.available
        ? '<span class="pstock"><svg class="ic"><use href="#i-check"/></svg>In Stock</span>'
        : '<span class="pstock out">Out of Stock</span>') +
      cta +
      '</div></div>';
  };
  var pxFromApi = function (p) {
    var vid = null;
    (p.variants || []).some(function (v) { if (v.available) { vid = v.id; return true; } return false; });
    if (!vid && p.variants && p.variants.length) vid = p.variants[0].id;
    return {
      title: p.title, url: p.url, vendor: p.vendor || '',
      img: p.featured_image || '', price: p.price,
      cap: p.compare_at_price || 0, available: !!p.available, vid: vid,
      opts: (p.variants || []).length > 1,
    };
  };

  // PDP variant sync: changing the variant updates the main price, sale
  // strike-through, savings %, SKU/MPN line, gallery image and the URL.
  var vdataEl = document.querySelector('[data-variant-data]');
  var vselMain = document.querySelector('.variant-select');
  if (vdataEl && vselMain) {
    var variants = [];
    try { variants = JSON.parse(vdataEl.textContent) || []; } catch (e) {}
    var vinv = {};
    var vinvEl = document.querySelector('[data-variant-inventory]');
    if (vinvEl) { try { vinv = JSON.parse(vinvEl.textContent) || {}; } catch (e) {} }
    var stockEl = document.querySelector('.stockline');
    var stockAvailHtml = stockEl && stockEl.style.color === '' ? stockEl.innerHTML : null;
    vselMain.addEventListener('change', function () {
      var vr = null;
      variants.some(function (x) { if (String(x.id) === vselMain.value) { vr = x; return true; } return false; });
      if (!vr) return;
      var pl = document.querySelector('[data-priceline]');
      if (pl) {
        var onSale = vr.compare_at_price && vr.compare_at_price > vr.price;
        var html = '<span class="now">' + pxMoney(vr.price) + '</span>';
        if (onSale) {
          var savedC = vr.compare_at_price - vr.price;
          var pct = Math.round(savedC * 100 / vr.compare_at_price);
          html += '<span class="was">' + pxMoney(vr.compare_at_price) + '</span>' +
            '<span class="save">Save ' + pxMoney(savedC) + ' (' + pct + '%)</span>';
        }
        pl.innerHTML = html;
      }
      var meta = document.querySelector('[data-vmeta]');
      if (meta) {
        var bits = [];
        if (vr.sku) bits.push('SKU: ' + vr.sku);
        if (vr.barcode) bits.push('MPN: ' + vr.barcode);
        meta.textContent = bits.join('  |  ');
      }
      var mainImg = document.querySelector('[data-main-image]');
      if (mainImg && vr.featured_image && vr.featured_image.src) {
        var vSrc = vr.featured_image.src;
        mainImg.setAttribute('srcset',
          sizedImg(vSrc, 550) + ' 550w, ' + sizedImg(vSrc, 1100) + ' 1100w, ' + sizedImg(vSrc, 1600) + ' 1600w');
        mainImg.src = sizedImg(vSrc, 1100);
      }
      // Availability drives the whole buy box, not just the price
      if (typeof vr.available === 'boolean') {
        if (stockEl) {
          if (vr.available && stockAvailHtml) {
            stockEl.style.color = '';
            stockEl.innerHTML = stockAvailHtml;
          } else if (vr.available) {
            stockEl.style.color = '';
            stockEl.innerHTML = '<svg class="ic"><use href="#i-check"/></svg>In Stock';
          } else {
            stockEl.style.color = '#C11F27';
            stockEl.textContent = 'Out of Stock';
          }
        }
        var atcBtn = document.querySelector('[data-main-atc]');
        if (atcBtn) {
          atcBtn.disabled = !vr.available;
          atcBtn.innerHTML = '<svg class="ic"><use href="#i-cart"/></svg>' +
            (vr.available ? 'Add to Cart' : 'Sold Out');
        }
        var satcBar = document.querySelector('[data-satc]');
        if (satcBar) {
          var sBtn = satcBar.querySelector('[data-satc-add]');
          if (sBtn) sBtn.disabled = !vr.available;
        }
        var lowEl = document.querySelector('.lowstock');
        if (lowEl) {
          var lowThr = parseInt(lowEl.dataset.lowThreshold, 10) || 0;
          var q = vinv[String(vr.id)];
          var showLow = vr.available && typeof q === 'number' && q > 0 && lowThr > 0 && q <= lowThr;
          lowEl.hidden = !showLow;
          if (showLow) {
            lowEl.innerHTML = '<svg class="ic"><use href="#i-zap"/></svg> Only ' + q +
              ' left in stock — order soon';
          }
        }
        var dispEl = document.querySelector('[data-dispatch]');
        if (dispEl) dispEl.hidden = !vr.available;
      }
      if (window.history && history.replaceState) {
        var vu = new URL(window.location.href);
        vu.searchParams.set('variant', vr.id);
        history.replaceState(null, '', vu.toString());
      }
    });
  }

  // "Customers also bought" — Shopify's native recommendations API
  document.querySelectorAll('[data-recs]').forEach(function (box) {
    if (!window.fetch) return;
    var grid = box.querySelector('[data-recs-grid]');
    var url = (box.dataset.recsUrl || '/recommendations/products') +
      '.json?product_id=' + box.dataset.productId +
      '&limit=' + (box.dataset.limit || 5) + '&intent=related';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.products) || [];
        if (!prods.length) return;
        grid.innerHTML = prods.map(function (p) { return pxCard(pxFromApi(p)); }).join('');
        box.hidden = false;
      })
      .catch(function () {});
  });

  // Recently viewed — remember this product, render the strip on any page
  var RV_KEY = 'px:recently-viewed';
  var rvRead = function () {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  };
  var capture = document.querySelector('[data-rv-capture]');
  if (capture) {
    try {
      var cur = JSON.parse(capture.textContent);
      var list = rvRead().filter(function (p) { return p.id !== cur.id; });
      list.unshift(cur);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage unavailable — skip silently */ }
  }
  document.querySelectorAll('[data-recent]').forEach(function (box) {
    var exclude = box.dataset.exclude;
    var items = rvRead().filter(function (p) { return String(p.id) !== String(exclude); }).slice(0, 5);
    if (!items.length) return;
    var grid = box.querySelector('[data-recent-grid]');
    grid.innerHTML = items.map(pxCard).join('');
    box.hidden = false;
  });

  // Wishlist — hearts everywhere, saved in the shopper's browser
  var WISH_KEY = 'px:wishlist';
  var wishRead = function () {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  };
  var wishWrite = function (list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };
  var wishItemFrom = function (host) {
    return {
      id: parseInt(host.dataset.id, 10),
      vid: parseInt(host.dataset.vid, 10) || null,
      title: host.dataset.title || '', url: host.dataset.url || '',
      img: host.dataset.img || '', vendor: host.dataset.vendor || '',
      price: parseInt(host.dataset.pc, 10) || 0,
      cap: parseInt(host.dataset.cap, 10) || 0,
      available: host.dataset.available === 'true',
      opts: host.dataset.opts === 'true',
    };
  };
  var wishSync = function () {
    var ids = {};
    wishRead().forEach(function (p) { ids[p.id] = true; });
    document.querySelectorAll('[data-wish-item]').forEach(function (host) {
      var btn = host.hasAttribute('data-wish') ? host : host.querySelector('[data-wish]');
      if (!btn) return;
      var on = !!ids[parseInt(host.dataset.id, 10)];
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (!btn.querySelector('[data-wish-label]')) {
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save for later');
      }
      var lab = btn.querySelector('[data-wish-label]');
      if (lab) lab.textContent = on ? 'Saved to wishlist' : 'Save for later';
    });
  };
  wishWrite(wishRead());
  wishSync();
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    var host = btn.closest('[data-wish-item]');
    if (!host) return;
    var item = wishItemFrom(host);
    var list = wishRead();
    var exists = list.some(function (p) { return p.id === item.id; });
    list = exists ? list.filter(function (p) { return p.id !== item.id; }) : [item].concat(list);
    wishWrite(list.slice(0, 60));
    wishSync();
  });

  // Wishlist page: render saved items, allow removal
  var wbox = document.querySelector('[data-wishlist]');
  if (wbox) {
    var wgrid = wbox.querySelector('[data-wishlist-grid]');
    var wempty = wbox.querySelector('[data-wishlist-empty]');
    var renderWish = function () {
      var items = wishRead();
      if (wempty) wempty.hidden = items.length !== 0;
      wgrid.innerHTML = items.map(function (p) {
        return pxCard(p).replace('<div class="pcard">',
          '<div class="pcard"><button class="wrm" type="button" data-wish-remove="' + p.id + '" aria-label="Remove">✕</button>');
      }).join('');
    };
    renderWish();
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wish-remove]');
      if (!rm) return;
      wishWrite(wishRead().filter(function (p) { return p.id !== parseInt(rm.dataset.wishRemove, 10); }));
      renderWish();
      wishSync();
    });
  }

  // Stat counters count up when they scroll into view
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var cuIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cuIo.unobserve(en.target);
        var final = en.target.textContent;
        var m = final.match(/[\d,]+/);
        if (!m) return;
        var num = parseInt(m[0].replace(/,/g, ''), 10);
        if (!num || num < 10) return;
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var t = Math.min((ts - start) / 1200, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          en.target.textContent = final.replace(m[0], Math.round(num * eased).toLocaleString('en-US'));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cuIo.observe(el); });
  }

  // Sticky nav shadow + back-to-top button
  var nav = document.querySelector('.nav');
  var toTop = document.createElement('button');
  toTop.className = 'to-top';
  toTop.type = 'button';
  toTop.setAttribute('aria-label', 'Back to top');
  toTop.innerHTML = '<svg class="ic" viewBox="0 0 24 24" width="18" height="18"><polyline points="18 15 12 9 6 15"/></svg>';
  document.body.appendChild(toTop);
  toTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  var prog = document.createElement('div');
  prog.className = 'scroll-progress';
  document.body.appendChild(prog);
  // Measure the nav's resting position once (and on resize) instead of
  // forcing layout with getBoundingClientRect on every scroll frame.
  var navTop = 0;
  var measureNav = function () {
    if (!nav) return;
    // A stuck position:sticky element reports its displaced offsetTop, so
    // neutralize stickiness for the measurement (init can run pre-scrolled).
    nav.style.position = 'static';
    navTop = nav.offsetTop;
    nav.style.position = '';
  };
  measureNav();
  var navActive = nav && nav.querySelector('a.active');
  if (navActive && navActive.scrollIntoView) {
    navActive.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
  var scrollTicking = false;
  var onScrollFrame = function () {
    scrollTicking = false;
    toTop.classList.toggle('show', window.scrollY > 600);
    if (nav) nav.classList.toggle('is-stuck', window.scrollY > navTop && navTop >= 0);
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(window.scrollY / max, 1) : 0) + ')';
  };
  var onScroll = function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(onScrollFrame);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measureNav(); onScroll(); }, { passive: true });
  onScrollFrame();

  // Scroll-reveal: elements fade-and-rise in as they enter the viewport,
  // with a small stagger inside card grids. No-JS and reduced-motion safe —
  // the classes are only added when the observer will run.
  if ('IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var els = [];
    // theme.js is deferred, so anything already on screen has painted —
    // hiding it now to replay an entrance would flash content away.
    var rvFold = window.innerHeight;
    var mark = function (el, extra) {
      if (el.getBoundingClientRect().top < rvFold) return false;
      el.classList.add('px-rv');
      if (extra) el.classList.add(extra);
      els.push(el);
      return true;
    };
    // Section headings sweep in from the left (their red underline draws after)
    document.querySelectorAll('.shead').forEach(function (el) { mark(el, 'px-rv-l'); });
    // Big panels scale in
    document.querySelectorAll('.finder, .promo').forEach(function (el) { mark(el, 'px-rv-zoom'); });
    document.querySelectorAll('.newsband .container, .formbox').forEach(function (el) { mark(el); });
    // Card grids rise with a stagger; compare/testimonial cards zoom instead
    [['.trust .titem', null], ['.depts .dept', null], ['.pgrid .pcard', null],
     ['.cat-rail .cat-chip', null], ['.compare .ccard', 'px-rv-zoom'],
     ['.quote', 'px-rv-zoom'], ['.pstat', null], ['.fgrid > div', null]]
      .forEach(function (pair) {
        document.querySelectorAll(pair[0]).forEach(function (el, i) {
          if (mark(el, pair[1])) {
            el.style.transitionDelay = Math.min((i % 12) * 60, 480) + 'ms';
          }
        });
      });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('px-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Product carousel: arrow paging + endless loading. When the shopper
  // nears the end, the next page of the collection is fetched and appended
  // (inserted before the final "View all" card) until products run out.
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-car-track]');
    var prev = car.querySelector('[data-car-prev]');
    var next = car.querySelector('[data-car-next]');
    if (!track || !prev || !next) return;
    var moreUrl = car.dataset.carMore;
    var htmlSrc = car.dataset.carSrc;
    var page = 1, loading = false, done = !(moreUrl || htmlSrc);
    var update = function () {
      prev.disabled = track.scrollLeft <= 5;
      next.disabled = done &&
        track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;
    };
    // HTML source (Section Rendering API): Shopify renders the cards
    // server-side in the requested sort (e.g. best-selling from real
    // order volume); we lift them straight into the track.
    var fetchHtmlPage = function (n, replace) {
      loading = true;
      fetch(htmlSrc + '&page=' + n)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var cards = tmp.querySelectorAll('.pcard:not(.vall)');
          if (cards.length < 24) done = true;
          var vall = track.querySelector('.vall');
          if (replace && cards.length) {
            track.querySelectorAll('.pcard:not(.vall)').forEach(function (el) { el.remove(); });
          }
          cards.forEach(function (c) { track.insertBefore(c, vall); });
          if (typeof wishSync === 'function') wishSync();
          loading = false;
          update();
        })
        .catch(function () { loading = false; done = true; update(); });
    };
    // Defer the server-rendered correction fetch until the carousel is
    // near the viewport — it must not compete with the LCP image.
    if (htmlSrc && window.fetch) {
      if ('IntersectionObserver' in window) {
        var kickIo = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          kickIo.disconnect();
          fetchHtmlPage(1, true);
        }, { rootMargin: '400px' });
        kickIo.observe(car);
      } else {
        fetchHtmlPage(1, true);
      }
    }
    var fromAjax = function (p) {
      var v = (p.variants || [])[0] || {};
      var img = (p.images || [])[0];
      return {
        title: p.title, url: '/products/' + p.handle,
        vendor: p.vendor || '',
        img: (img && (img.src || img)) || '',
        price: Math.round(parseFloat(v.price || '0') * 100),
        cap: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
        available: v.available !== false, vid: v.id || null,
        opts: (p.variants || []).length > 1,
      };
    };
    var loadMore = function () {
      if (done || loading || !window.fetch) return;
      if (track.scrollLeft < track.scrollWidth - track.clientWidth * 2.5) return;
      if (htmlSrc) {
        page += 1;
        fetchHtmlPage(page, false);
        return;
      }
      loading = true;
      // Page size must match the server-rendered count, or the seam
      // between page 1 and page 2 silently skips products.
      if (!loadMore.pageSize) {
        loadMore.pageSize = track.querySelectorAll('.pcard:not(.vall)').length || 24;
      }
      var pageSize = loadMore.pageSize;
      page += 1;
      fetch(moreUrl + '?limit=' + pageSize + '&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data && data.products) || [];
          if (prods.length < pageSize) done = true;
          var vall = track.querySelector('.vall');
          var holder = document.createElement('div');
          prods.forEach(function (p) {
            holder.innerHTML = pxCard(fromAjax(p));
            track.insertBefore(holder.firstChild, vall);
          });
          loading = false;
          update();
        })
        .catch(function () { loading = false; done = true; update(); });
    };
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      loadMore();
    });
    var carTicking = false;
    track.addEventListener('scroll', function () {
      if (carTicking) return;
      carTicking = true;
      requestAnimationFrame(function () { carTicking = false; update(); loadMore(); });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  // Brands directory: alphabet quick-jump + live search
  var brandsPage = document.querySelector('[data-brands]');
  if (brandsPage) {
    var alphaBar = brandsPage.querySelector('[data-alpha]');
    var bgroups = brandsPage.querySelectorAll('.bgroup');
    if (alphaBar) {
      bgroups.forEach(function (g) {
        var a = document.createElement('a');
        a.href = '#' + g.id;
        a.textContent = g.dataset.letter;
        alphaBar.appendChild(a);
      });
    }
    var bsearch = brandsPage.querySelector('[data-brand-search]');
    if (bsearch) {
      bsearch.addEventListener('input', function () {
        var q = bsearch.value.trim().toLowerCase();
        var any = false;
        bgroups.forEach(function (g) {
          var vis = 0;
          g.querySelectorAll('.bcard').forEach(function (c) {
            var hit = !q || c.textContent.toLowerCase().indexOf(q) !== -1;
            c.style.display = hit ? '' : 'none';
            if (hit) vis += 1;
          });
          g.style.display = vis ? '' : 'none';
          if (vis) any = true;
        });
        if (alphaBar) alphaBar.style.display = q ? 'none' : '';
        var none = brandsPage.querySelector('[data-brands-empty]');
        if (none) none.hidden = any;
      });
    }
  }

  // ============ AJAX cart + mini-cart drawer ============
  // Add-to-cart and quantity edits go through /cart/*.js so the shopper
  // never loses their place — the single biggest mobile-conversion lever.
  var drawer = document.querySelector('[data-cart-drawer]');
  var veil = document.querySelector('.cdveil');
  var announceEl = document.querySelector('[data-cart-announce]');
  var announce = function (msg) { if (announceEl) announceEl.textContent = msg; };
  var cartFetchJson = function (url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    });
  };
  var sizedImg = function (url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  };

  // Header badge + total (any page)
  var syncHeader = function (cart) {
    document.querySelectorAll('[data-cart-badge]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = pxMoney(cart.total_price);
    });
  };

  // Free-shipping progress (drawer + cart page share the markup)
  var syncShipbar = function (bar, total) {
    if (!bar) return;
    var thr = parseInt(bar.dataset.threshold, 10) || 0;
    if (thr <= 0) return;
    var p = bar.querySelector('p');
    var fill = bar.querySelector('.bar i');
    var moreText = bar.dataset.shipMore || 'more to unlock FREE SHIPPING';
    var doneText = bar.dataset.shipDone || "You've unlocked FREE SHIPPING!";
    if (total >= thr) {
      bar.classList.add('done');
      if (p) p.innerHTML = '<svg class="ic"><use href="#i-check"/></svg> <span>' + escHtml(doneText) + '</span>';
      if (fill) fill.style.width = '100%';
    } else {
      bar.classList.remove('done');
      if (p) p.innerHTML = '<svg class="ic"><use href="#i-truck"/></svg> <span>Add <b>' +
        pxMoney(thr - total) + '</b> ' + escHtml(moreText) + '</span>';
      if (fill) fill.style.width = Math.max(Math.round(total * 100 / thr), 4) + '%';
    }
  };

  var cdItemHtml = function (item) {
    var showVar = !item.product_has_only_default_variant && item.variant_title;
    return '<div class="cd-item" data-cd-line="' + escHtml(item.key) + '">' +
      '<a class="cd-im" href="' + escHtml(item.url) + '" tabindex="-1">' +
      (item.image ? '<img src="' + escHtml(sizedImg(item.image, 160)) + '" width="80" height="80" alt="" loading="lazy">' : '') +
      '</a>' +
      '<div class="cd-t">' +
      '<a class="cd-title" href="' + escHtml(item.url) + '">' + escHtml(item.product_title) + '</a>' +
      (showVar ? '<span class="cd-var">' + escHtml(item.variant_title) + '</span>' : '') +
      '<span class="cd-price">' + pxMoney(item.final_price) +
      (item.original_price > item.final_price ? ' <s class="pwas">' + pxMoney(item.original_price) + '</s>' : '') +
      '</span>' +
      '<div class="cd-qtyrow"><div class="qty cd-qty">' +
      '<button type="button" data-cd-qty="down" aria-label="Decrease quantity">−</button>' +
      '<input type="number" inputmode="numeric" value="' + item.quantity + '" min="1" aria-label="Quantity">' +
      '<button type="button" data-cd-qty="up" aria-label="Increase quantity">+</button></div>' +
      '<button class="cd-rm" type="button" data-cd-remove aria-label="Remove ' + escHtml(item.product_title) + '">Remove</button>' +
      '</div></div>' +
      '<div class="cd-line">' + pxMoney(item.final_line_price) + '</div></div>';
  };

  var cdRender = function (cart) {
    syncHeader(cart);
    if (!drawer) return;
    cdClearError();
    var count = drawer.querySelector('[data-cd-count]');
    if (count) count.textContent = '(' + cart.item_count + ')';
    var items = drawer.querySelector('[data-cd-items]');
    if (items) items.innerHTML = cart.items.map(cdItemHtml).join('');
    var empty = drawer.querySelector('[data-cd-empty]');
    if (empty) empty.hidden = cart.item_count !== 0;
    var foot = drawer.querySelector('[data-cd-foot]');
    if (foot) foot.hidden = cart.item_count === 0;
    var sub = drawer.querySelector('[data-cd-subtotal]');
    if (sub) sub.textContent = pxMoney(cart.total_price);
    syncShipbar(drawer.querySelector('[data-cd-shipbar]'), cart.total_price);
  };

  var cdError = function (msg) {
    if (!drawer) return;
    var box = drawer.querySelector('[data-cd-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  };
  var cdClearError = function () {
    if (!drawer) return;
    var box = drawer.querySelector('[data-cd-error]');
    if (box) box.hidden = true;
  };

  var cdBusy = function (on) { if (drawer) drawer.classList.toggle('busy', on); };
  var refreshCart = function () {
    return cartFetchJson((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { if (res.ok) cdRender(res.d); });
  };

  var lastFocus = null;
  var cdOpen = function () {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    if (veil) veil.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('open');
      if (veil) veil.classList.add('open');
      document.body.classList.add('cd-open');
      drawer.focus({ preventScroll: true });
    });
  };
  var cdClose = function () {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (veil) veil.classList.remove('open');
    document.body.classList.remove('cd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  if (drawer) {
    // Reveal for JS users (CSS keeps it off-screen until .open)
    drawer.hidden = false;
    if (veil) veil.hidden = false;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { cdClose(); return; }
      var opener = e.target.closest('[data-cart-open]');
      if (opener && window.fetch) {
        e.preventDefault();
        cdOpen();
        refreshCart();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape') { cdClose(); return; }
      if (e.key !== 'Tab') return;
      var focusables = Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'),
        function (el) { return el.offsetParent !== null && el.tabIndex !== -1; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    // Quantity + remove inside the drawer (network calls debounced per line)
    var cdTimers = {};
    var cdPending = {};
    var cdInflight = [];
    var cdSend = function (key, qty) {
      delete cdPending[key];
      cdBusy(true);
      var p = cartFetchJson((CFG.cartChangeUrl || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (res) {
          if (res.ok) { cdRender(res.d); announce('Cart updated'); }
          else { cdError(res.d.description || res.d.message || 'Could not update cart.'); refreshCart(); }
        })
        .catch(function () { cdError('Network error — please try again.'); })
        .then(function () {
          cdBusy(false);
          var i = cdInflight.indexOf(p);
          if (i !== -1) cdInflight.splice(i, 1);
        });
      cdInflight.push(p);
      return p;
    };
    var cdChange = function (key, qty) {
      clearTimeout(cdTimers[key]);
      cdPending[key] = qty;
      cdTimers[key] = setTimeout(function () { cdSend(key, qty); }, 300);
    };
    // Checkout must never race a debounced quantity edit: flush pending
    // changes first, then proceed to checkout.
    var checkoutForm = drawer.querySelector('.cd-foot form');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (e) {
        var keys = Object.keys(cdPending);
        if ((!keys.length && !cdInflight.length) || !window.fetch) return;
        e.preventDefault();
        var sends = keys.map(function (k) {
          clearTimeout(cdTimers[k]);
          return cdSend(k, cdPending[k]);
        }).concat(cdInflight.slice());
        Promise.all(sends).then(function () { checkoutForm.submit(); });
      });
    }
    drawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cd-remove]');
      var stepBtn = e.target.closest('[data-cd-qty]');
      var line = e.target.closest('[data-cd-line]');
      if (!line) return;
      var key = line.dataset.cdLine;
      if (rm) { cdChange(key, 0); return; }
      if (stepBtn) {
        // The stepper floors at 1 — deleting a line is the explicit
        // Remove button's job, never an accidental minus-tap.
        var input = line.querySelector('.cd-qty input');
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + (stepBtn.dataset.cdQty === 'up' ? 1 : -1));
        input.value = v;
        cdChange(key, v);
      }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('.cd-qty input');
      var line = e.target.closest('[data-cd-line]');
      if (!input || !line) return;
      var v = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = v;
      cdChange(line.dataset.cdLine, v);
    });

    // Intercept every add-to-cart form (PDP, cards, sticky bar, wishlist)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1 || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      cdBusy(true);
      cartFetchJson((CFG.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (res) {
          if (res.ok) announce('Added to cart');
          return refreshCart().catch(function () {}).then(function () {
            cdOpen();
            if (!res.ok) cdError(res.d.description || res.d.message || 'Could not add this item.');
          });
        }, function () { form.submit(); })
        .then(function () { if (btn) btn.disabled = false; cdBusy(false); });
    }, true);
  }

  // Cart page: quantity edits apply instantly via /cart/change.js —
  // no "Update Cart" round-trip, no page reload.
  if (CFG.isCartPage && window.fetch) {
    var cartRoot = document.querySelector('[data-cart-page]');
    if (cartRoot) {
      var cpTimers = {};
      var cpApply = function (cart) {
        syncHeader(cart);
        if (cart.item_count === 0) { window.location.reload(); return; }
        var byKey = {};
        cart.items.forEach(function (it) { byKey[it.key] = it; });
        cartRoot.querySelectorAll('[data-line-key]').forEach(function (row) {
          var it = byKey[row.dataset.lineKey];
          if (!it) { row.remove(); return; }
          var qtyIn = row.querySelector('input[name="updates[]"]');
          if (qtyIn && document.activeElement !== qtyIn) qtyIn.value = it.quantity;
          var lp = row.querySelector('.line-price');
          if (lp) lp.textContent = pxMoney(it.final_line_price);
        });
        var subEl = cartRoot.querySelector('[data-cart-subtotal]');
        if (subEl) subEl.textContent = pxMoney(cart.total_price);
        var totEl = cartRoot.querySelector('[data-cart-grandtotal]');
        if (totEl) totEl.textContent = pxMoney(cart.total_price);
        var ckAmt = cartRoot.querySelector('[data-checkout-amount]');
        if (ckAmt) ckAmt.textContent = pxMoney(cart.total_price);
        var cnt = document.querySelector('[data-cart-itemcount]');
        if (cnt) cnt.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart';
        var bar = cartRoot.querySelector('[data-cd-shipbar]');
        syncShipbar(bar, cart.total_price);
        var savRow = cartRoot.querySelector('[data-cart-savings-row]');
        if (savRow) {
          savRow.hidden = !(cart.total_discount > 0);
          var savEl = savRow.querySelector('[data-cart-savings]');
          if (savEl) savEl.textContent = '−' + pxMoney(cart.total_discount);
        }
        var shipCell = cartRoot.querySelector('[data-cart-shipping]');
        if (shipCell && bar) {
          var sThr = parseInt(bar.dataset.threshold, 10) || 0;
          var free = sThr > 0 && cart.total_price >= sThr;
          shipCell.textContent = free ? 'FREE' : 'Calculated at checkout';
          shipCell.classList.toggle('free', free);
        }
        announce('Cart updated');
      };
      var cpChange = function (key, qty, fallback) {
        clearTimeout(cpTimers[key]);
        cpTimers[key] = setTimeout(function () {
          cartFetchJson((CFG.cartChangeUrl || '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty }),
          })
            .then(function (res) {
              if (res.ok) cpApply(res.d);
              else window.location.reload();
            })
            .catch(function () { if (fallback) fallback(); });
        }, 300);
      };
      cartRoot.addEventListener('change', function (e) {
        var input = e.target.closest('input[name="updates[]"]');
        var row = e.target.closest('[data-line-key]');
        if (!input || !row) return;
        var v = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = v;
        cpChange(row.dataset.lineKey, v,
          function () { input.form && input.form.submit(); });
      });
      cartRoot.addEventListener('click', function (e) {
        var rm = e.target.closest('a.rm');
        var row = e.target.closest('[data-line-key]');
        if (!rm || !row) return;
        e.preventDefault();
        cpChange(row.dataset.lineKey, 0, function () { window.location.href = rm.href; });
      });
    }
  }

  // Button press ripple
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest('.btn,.atc,.browse-btn,.fbtn');
    if (!b || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = b.getBoundingClientRect();
    var d = Math.max(r.width, r.height);
    var s = document.createElement('span');
    s.className = 'ripple';
    s.style.width = s.style.height = d + 'px';
    s.style.left = (e.clientX - r.left - d / 2) + 'px';
    s.style.top = (e.clientY - r.top - d / 2) + 'px';
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 600);
  });
})();
